// Analytics library
import { Analytics, GTag, GTagPageviewParams, GTagEventObserver, GTagEventData, GTagPageviewObserver } from '@plaudit/analytics';
import MicrosoftUniversalEventTracking from "@plaudit/analytics/dist/tracker/MicrosoftUniversalEventTracking";

// Analytics on visitor which are submitted on form submission
import WebsiteVisitorAnalytics from "./WebsiteVisitorAnalytics";

// GA enhancements
// 2021-10-18: Disabled. TODO: Put back but need to not call ga().
// declare function require(moduleName: string): any;
// const EnhancedAnalytics = require('./EnhancedAnalytics.js');


// Reporting conversions / events to other platforms (e.g. Microsoft Ads)
export function init() {
	Analytics.setup();
	const msTracking = MicrosoftUniversalEventTracking.getInstance();

	// 2021-10-18: Disabled:  EnhancedAnalytics.init(); // TODO EnhancedAnalytics should really be rewritten/upgraded.

	WebsiteVisitorAnalytics.getInstance();

	const gtag = GTag.getInstance();

	if (gtag !== null) {
		
		gtag.addObservers([
			// Mirror all pageviews to MS Ads
			new GTagPageviewObserver(
				true,
				(tracker: GTag, params: GTagPageviewParams) => {
					if (msTracking !== null) msTracking.trackPageview(params.page_path);
				}
			),
			// Mirror all events to MS Ads
			new GTagEventObserver(
				true,
				(tracker: GTag, data: GTagEventData) => {
					if (data.eventParams !== undefined) {
						if (msTracking !== null) msTracking.trackEvent(
							data.eventParams.event_category,
							data.eventName,
							data.eventParams.event_label,
							data.eventParams.value,
							data.eventParams.non_interaction
						);
					}
				}
			)
		]);

	}
}
